import { useQuery } from 'react-query';

import api from '@root/api/newApi';

const countFiles = (templateType) => api.files.count({ templateType });

const useFileCounter = (templateType) => useQuery(['countFiles', templateType], () => countFiles(templateType));

export default useFileCounter;
